import BalanceHoursCorrection from "app/models/balanceHoursCorrection"
import { IPostBalanceHoursCorrectionPayload } from "app/models/correction"

export interface IGetBalanceHoursCorrectionsPayload {
  payload: { id: string; params?: { sort?: string[] } }
}

export enum Types {
  GET = "BALANCE_HOURS_CORRECTIONS_GET",
  GET_SUCCESS = "BALANCE_HOURS_CORRECTIONS_GET_SUCCESS",
  GET_FAIL = "BALANCE_HOURS_CORRECTIONS_GET_FAIL",
  POST = "BALANCE_HOURS_CORRECTIONS_POST",
  POST_SUCCESS = "BALANCE_HOURS_CORRECTIONS_POST_SUCCESS",
  POST_FAIL = "BALANCE_HOURS_CORRECTIONS_POST_FAIL",
}

export type Action =
  | GetBalanceHoursCorrectionsAction
  | GetBalanceHoursCorrectionsSuccessAction
  | GetBalanceHoursCorrectionsFailAction
  | PostBalanceHoursCorrectionsAction
  | PostBalanceHoursCorrectionsSuccessAction
  | PostBalanceHoursCorrectionsFailAction

export type GetBalanceHoursCorrectionsAction = {
  payload: IGetBalanceHoursCorrectionsPayload
  type: Types.GET
}

export type GetBalanceHoursCorrectionsSuccessAction = {
  payload: { data: BalanceHoursCorrection[] }
  type: Types.GET_SUCCESS
}

export type GetBalanceHoursCorrectionsFailAction = {
  payload: { errors: object }
  type: Types.GET_FAIL
}

export type PostBalanceHoursCorrectionsAction = {
  payload: IPostBalanceHoursCorrectionPayload
  type: Types.POST
}

export type PostBalanceHoursCorrectionsSuccessAction = {
  type: Types.POST_SUCCESS
}

export type PostBalanceHoursCorrectionsFailAction = {
  payload: { errors: object }
  type: Types.POST_FAIL
}

export function getBalanceHoursCorrections(
  payload: IGetBalanceHoursCorrectionsPayload,
): GetBalanceHoursCorrectionsAction {
  return {
    payload,
    type: Types.GET,
  }
}

export function getBalanceHoursCorrectionsSuccess(
  data: BalanceHoursCorrection[],
): GetBalanceHoursCorrectionsSuccessAction {
  return {
    payload: { data },
    type: Types.GET_SUCCESS,
  }
}

export function getBalanceHoursCorrectionsFail(errors: object): GetBalanceHoursCorrectionsFailAction {
  return {
    payload: { errors },
    type: Types.GET_FAIL,
  }
}

export function postBalanceHoursCorrections(
  payload: IPostBalanceHoursCorrectionPayload,
): PostBalanceHoursCorrectionsAction {
  return {
    payload,
    type: Types.POST,
  }
}

export function postBalanceHoursCorrectionsSuccess(): PostBalanceHoursCorrectionsSuccessAction {
  return {
    type: Types.POST_SUCCESS,
  }
}

export function postBalanceHoursCorrectionsFail(errors: object): PostBalanceHoursCorrectionsFailAction {
  return {
    payload: { errors },
    type: Types.POST_FAIL,
  }
}
